var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDarkModeRainbow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_23255_62179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9274 17.9323C23.0671 17.9323 24.2068 17.6879 24.924 17.4532C25.1107 17.3848 25.2286 17.3555 25.3563 17.3555C25.6314 17.3555 25.9163 17.5803 25.9163 17.9323C25.9163 18.0301 25.8869 18.255 25.8083 18.4799C24.6293 21.5208 21.1709 23.9163 17.182 23.9163C11.739 23.9163 7.58301 20.0346 7.58301 14.5981C7.58301 10.7261 9.89187 7.05945 13.3306 5.69056C13.5467 5.60256 13.7727 5.58301 13.8906 5.58301C14.2541 5.58301 14.4506 5.86656 14.4506 6.12079C14.4506 6.21856 14.431 6.36523 14.3327 6.59012C13.9987 7.35279 13.7531 8.80967 13.7531 9.8559C13.7531 14.823 16.9363 17.9323 21.9274 17.9323Z",
    fill: "url(#paint0_linear_23255_62179)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_23255_62179",
    x: -3.875,
    y: -4.15625,
    width: 41.25,
    height: 41.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.71875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23255_62179"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.71875,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_23255_62179"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.71875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.57812
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23255_62179",
    result: "effect2_dropShadow_23255_62179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_23255_62179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23255_62179",
    x1: 7.58301,
    y1: 14.7618,
    x2: 25.9163,
    y2: 14.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6AE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55D6F0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkModeRainbow);
export default __webpack_public_path__ + "static/media/icon-dark-mode-rainbow.9fe30f850c967c99ffd0f7873803b99e.svg";
export { ForwardRef as ReactComponent };